// src/js/theme/components/analytics-events.js

export const analyticsEvents = {
  init: function () {
    try {
      trackAddToCart();
      trackClickViewItem();
      trackClickSocialsEvent();
      trackViewPromotions();
      trackClickPromotion();
      insertPageClassIdToBlocks();
      console.info("Analytics events tracking initialized");
    } catch (error) {
      console.error("GA4 tracking error:", error);
    }

    function pushGAEvent(eventName, itemData = {}, extraParams = {}) {
      if (typeof gtag === "function") {
        const payload = {
          items: [itemData],
          value: itemData.price || 0,
          currency: itemData.currency || "CZK",
          ...extraParams,
        };
        console.info(`GA4 Event '${eventName}' sent`, payload);
        gtag("event", eventName, payload);
      } else {
        console.warn("gtag not defined");
      }
    }

    function getItemDataFromElement(el) {
      let itemData = {
        item_id: el.dataset.productid || "",
        item_name: el.dataset.productname || el.textContent.trim(),
        price: parseFloat((el.dataset.productprice || "0").replace(",", ".")),
        item_category: el.dataset.producttype || "",
        item_brand: el.dataset.item_brand || "",
        item_url: el.dataset.producturl || el.href || window.location.href,
        quantity: 1,
        currency: "CZK",
      };

      const container = el.closest(
        "li, .product, .event-tile, .tile-switching"
      );
      const dataEl = container?.querySelector(".gtm4wp_productdata");

      if (dataEl?.dataset.gtm4wp_product_data) {
        try {
          const data = JSON.parse(dataEl.dataset.gtm4wp_product_data);
          itemData = {
            ...itemData,
            item_id: data.item_id || itemData.item_id,
            item_name: data.item_name || itemData.item_name,
            price: parseFloat(data.price || itemData.price),
            item_category: data.item_category || itemData.item_category,
            item_brand: data.item_brand || itemData.item_brand,
            item_url: data.productlink || itemData.item_url,
          };
        } catch (e) {
          console.warn("Invalid product JSON", e);
        }
      }

      return itemData;
    }

    function trackAddToCart() {
      document.querySelectorAll(".track_add_to_cart").forEach((el) => {
        el.addEventListener("click", () => {
          const itemData = getItemDataFromElement(el);
          pushGAEvent("add_to_cart", itemData);
        });
      });
    }

    function trackClickViewItem() {
      document
        .querySelectorAll(".track_view_item, .woocommerce-loop-product__link")
        .forEach((el) => {
          el.addEventListener("click", () => {
            const itemData = getItemDataFromElement(el);
            pushGAEvent("view_item", itemData);
          });
        });
    }

    function trackClickSocialsEvent() {
      document.querySelectorAll(".share_button").forEach((el) => {
        el.addEventListener("click", () => {
          const platform = el.dataset.type || "unknown";
          const url = el.dataset.elementurl || window.location.href;
          if (typeof gtag === "function") {
            console.info("GA4 Event 'share' sent", { method: platform, url });
            gtag("event", "share", {
              method: platform,
              content_type: "page",
              item_id: url,
            });
          }
        });
      });
    }

    function trackViewPromotions() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target;
              const itemData = getItemDataFromElement(el);
              observer.unobserve(el);
              console.info("GA4 Event 'view_promotion' sent");
              gtag("event", "view_promotion", {
                promotion_id:
                  el.dataset.promotion_id || "promo_" + itemData.item_id,
                promotion_name: el.dataset.promotion_name || "Homepage Promo",
                creative_name: el.dataset.creative_name || "Homepage Banner",
                creative_slot: el.dataset.creative_slot || "banner_top",
                items: [itemData],
              });
            }
          });
        },
        { threshold: 0.5 }
      );

      document.querySelectorAll(".track_view_promotion").forEach((el) => {
        observer.observe(el);
      });
    }

    function trackClickPromotion() {
      document.querySelectorAll(".track_click_promotion").forEach((el) => {
        el.addEventListener("click", () => {
          const itemData = getItemDataFromElement(el);
          gtag("event", "select_promotion", {
            promotion_id:
              el.dataset.promotion_id || "promo_" + itemData.item_id,
            promotion_name: el.dataset.promotion_name || "Homepage Promo",
            creative_name: el.dataset.creative_name || "Homepage Banner",
            creative_slot: el.dataset.creative_slot || "banner_top",
            items: [itemData],
          });
        });
      });
    }

    function insertPageClassIdToBlocks() {
      const bodyClassList = document.body.classList;
      if (bodyClassList.length > 0) {
        const firstBodyClass = bodyClassList[0];
        document.querySelectorAll(".block-highlights").forEach((block) => {
          block.classList.add("from-" + firstBodyClass);
        });
      }
    }
  },
};
